import getBasePath from '@/common/functions/api-resource';
import genericActions from './generic-resource';

const basePath = getBasePath('api', 'fornecedor');

const fornecedorActions = {
  ...genericActions(basePath),
  pesquisar: { method: 'GET', url: `${basePath}` },
  ativarMassa: { method: 'PUT', url: `${basePath}/ativacao-massa` },
  buscar: { method: 'GET', url: `${basePath}/{id}` },
  listarFiltrado: { method: 'GET', url: `${basePath}?tamanhoPagina={size}&numeroPagina={page}&filtro={filter}` },
  buscarApuracoesImpactadas: { method: 'GET', url: `${basePath}/{idFornecedor}/apuracoes_impactadas` },
};

export default (resource) => resource(`${basePath}`, {}, fornecedorActions);
